import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/config';
import { baseQueryWithInterceptor } from '../../utils/baseQueryWithInterceptor';
import commentApi from './commentApi';

export type ReactionType = 'LIKE' | 'DISLIKE';

export interface ToggleReactionResponse {
  action: 'added' | 'removed' | 'changed';
  reaction?: {
    id: string;
    userId: string;
    commentId: string;
    type: ReactionType;
  };
}

const commentReactionApi = createApi({
  reducerPath: 'commentReactionApi',
  baseQuery: baseQueryWithInterceptor(
    `${config.API_BASE_URL}/comment-reaction`
  ),
  tagTypes: ['reaction'],

  endpoints: (builder) => ({
    // NEW: Consolidated toggle endpoint
    toggleCommentReaction: builder.mutation<
      ToggleReactionResponse,
      { commentId: string; reactionType: ReactionType }
    >({
      query: ({ commentId, reactionType }) => ({
        url: '/toggle',
        method: 'POST',
        body: { commentId, reactionType },
      }),
      invalidatesTags: ['reaction'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(commentApi.util.invalidateTags(['comment']));
        } catch {
          // no-op
        }
      },
    }),
  }),
});

export const { useToggleCommentReactionMutation } = commentReactionApi;
// export const { useLikeCommentMutation, useDislikeCommentMutation } = commentReactionApi; // OLD

export default commentReactionApi;
